import service from '@/utils/server';

const modName='/md/soldtoAuthorization/';
//查询方法
export const pageInfo = data => {
  return service({
    url: modName + 'pageInfo',
    method: 'post',
    data
  });
};

export const deleteData = data => {
  return service({
    url: modName + 'delete/' + data.id,
    method: 'post'
  });
};

export const soldtoAuthorizationEdit = data => {
  return service({
    url: modName + 'soldtoAuthorizationEdit/' + data.id,
    method: 'post'
  });
};

export const submit = data => {
  return service({
    url: modName + 'submit',
    method: 'post',
    data
  });
};

//模板下载
export const downtemplate = data => {
  let config = {
    timeout: 500000, // 请求超时时间
    responseType: "blob"
  };
  return service({
    ...config,
    url: modName + 'template/' + data.templateName,
    method: 'post',
    data
  });
};

//导入
export const uploadSoldtoAuthorization = data => {
  let config = {
    timeout: 500000, // 请求超时时间
    headers: {
      "Content-Type": "multipart/form-data"
    },
    responseType: "blob"
  };
  return service({
    ...config,
    url: modName + 'uploadSoldtoAuthorization',
    method: 'post',
    data
  });
};

//导出
export const exportData = data => {
  let config = {
    timeout: 500000, // 请求超时时间
    responseType: "blob"
  };
  return service({
    ...config,
    url: modName + 'export',
    method: 'post',
    data
  });
};


//批量删除
export const deleteBatch = data => {
  return service({
    url: modName + 'deleteBatch',
    method: 'post',
    data
  })
};



// WEBPACK FOOTER //
// ./src/page/md/soldToAuthorization/api/index.js